import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DictionaryModule, CommonUIElementsModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { VisitorScanRegistrationQRCodeComponent } from './component/visitor-scan-registration-qrcode.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { CommonLayoutModule } from '@sdbn/common';



@NgModule({
  declarations: [
    VisitorScanRegistrationQRCodeComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    DictionaryModule,
    CommonTranslationModule,
    ZXingScannerModule,
    CommonUIElementsModule
]
})
export class VisitorScanRegistrationQRCodeModule { }
